import { render, staticRenderFns } from "./StatementOfFinancialPosition.vue?vue&type=template&id=40c0985c&scoped=true"
import script from "./StatementOfFinancialPosition.vue?vue&type=script&lang=js"
export * from "./StatementOfFinancialPosition.vue?vue&type=script&lang=js"
import style0 from "./StatementOfFinancialPosition.vue?vue&type=style&index=0&id=40c0985c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0985c",
  null
  
)

export default component.exports